// extracted by mini-css-extract-plugin
export default {"container":"detailsCard_container__pZy+5"};